<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <Header />
    <div class="container">
      <SecondHeader />
      <p class="title_section">Reportes</p>

      <div class="row">
        <div class="col-md-3" style="margin-top: 20px">
          <div class="form-group">
            <label>Departamento</label>
            <DepartamentSelect />
          </div>
          <div class="form-group">
            <label>Municipio</label>
            <MunicipalitySelect />
          </div>
          <div class="form-group">
            <label>Nivel de Adaptación</label>
            <AdaptationLevelSelect />
          </div>
          <div class="form-group">
            <label>Amenazas</label>
            <ThreatSelect />
          </div>
          <div class="form-group">
            <label>Gremios</label>
            <GuildSelect />
          </div>
          <!--<div class="form-group">
            <a class="btn btn-info btn-aceptar width100">Filtrar</a>
          </div>-->
        </div>
        <div class="col-md-9">
          
          <div class="row">
            <div class="container-center">
              <Chart ref="chart" :series="series" :options="options" />
            </div>
          </div>
          <div class="container-center">
            <div class="form-group">
              <a @click="Exportar()" class="btn btn-info btn-aceptar width100">Generar Reporte</a>
            </div>&nbsp;&nbsp;&nbsp;
            <div class="form-group">
              <a @click="reset()" class="btn btn-info btn-aceptar width100">Limpiar</a>
            </div>
          </div>
          <div class="container-experiences">
            <h3 style="margin-bottom: 15px">Experiencias</h3>

            <div class="row">
              <div class="col-md-4 col-sm-12" v-for="(exp, index) in experiences" :key="index">
                <p>
                  <input type="checkbox" id="checkbox" v-model="checkedExperiences" :value="exp.id" />
                  Código:{{exp.code}} {{exp.code}}
                </p>
              </div>
            </div>

            <hr />
            <Reports />
          </div>
          <div class="row">
            
          </div>
        </div>
      </div>
      <sweet-modal ref="modalSuccess" icon="success">Selecciona una experiencia para exportar</sweet-modal>
      <sweet-modal ref="modalError" icon="error">Selecciona una experiencia para exportar</sweet-modal>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "./partials/Header";
import SecondHeader from "./partials/SecondHeader";
import Footer from "./partials/Footer";
import DepartamentSelect from "./selects/DepartamentSelect";
import MunicipalitySelect from "./selects/MunicipalitySelect";
import AdaptationLevelSelect from "./selects/AdaptationLevel";
import ThreatSelect from "./selects/ThreatsSelect";
import GuildSelect from "./selects/GuildSelect";
import ObjectiveSelect from "./selects/ObjectivesSelect";
import IndicatorSelect from "./selects/IndicatorsSelect";
import Reports from "./Reports";
import Chart from "./Reports/Chart";
import api from "../../api/index";
import config from "../../helpers/config";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from 'axios'

export default {
  components: {
    Loading,
    Header,
    SecondHeader,
    Footer,
    DepartamentSelect,
    MunicipalitySelect,
    AdaptationLevelSelect,
    ThreatSelect,
    GuildSelect,
    ObjectiveSelect,
    IndicatorSelect,
    Reports,
    Chart,
    SweetModal
  },
  data() {
    return {
      isClean: 0,
      isLoading: false,
      experiences: [],
      checkedExperiences: [],
      options: {
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          forceNiceScale: true,
          decimalsInFloat: 0,
          tickAmount: 1
        }
      },
      series: [
        {
          name: "Departamento",
          data: []
        }
      ]
    };
  },
  watch: {
    helperExperiences(val) {
      this.chartData()
    }
  },
  methods: {
    saveExperiences: api.saveExperiences,
    apiGetExperiences: api.getExperiences,
    reset() {
      this.apiGetExperiences()
      this.$store.state.valueDepartment = []
      this.$store.state.valueMunicipality = []
      this.$store.state.valueLevels = []
      this.$store.state.valueAmenazas = []
      this.$store.state.valueGuild = []
      this.$store.state.experiencesSelected = []
      this.$store.state.filter = []
    },
    downloadItems(url) {
      const link = document.createElement("a");
      link.target = "_new";
      let url2 = url;
      if (url2 && url2.includes("pnudback")) {
        url2 = url2.replace("pnudback", "pnudback2020");
      }
      link.href = `${url2}`;
      // link.href = url;
      link.download = "reporte.pdf";
      link.dispatchEvent(new MouseEvent("click"));
    },
    async Exportar() {
      this.isLoading = true
      if (this.$store.state.experiencesSelected.length > 0) {
        const url = await this.saveExperiences();
        this.isLoading = false
        setTimeout(() => {
          this.downloadItems(url);  
        }, 3000);
      } else {
        this.isLoading = false
        this.$refs.modalError.open();
      }
    },
    sendExperiencesToReport() {
      
      axios
        .post(`${config.urlApi}/scriptFunctions/generatePDFbyID`, {
          id: this.checkedExperiences
        })
        .then(response => {
          //console.log(response);
          this.isLoading = false
        })
        .catch(e => {
          console.error(e);
        });
    },
    getExperiences() {
      let departament_id = localStorage.getItem("depart_id");
      let municipality_id = localStorage.getItem("municip_id");
      let adaptation_level_id = localStorage.getItem("adapt_id");
      let threat_id = localStorage.getItem("thr_id");
      let guild_id = localStorage.getItem("gui_id");
      let objective_id = localStorage.getItem("obj_id");
      let indicator_id = localStorage.getItem("indi_id");

      const url = `${config.urlApi}/experiences?&filter[where][expStatusId]=1`;
      const filter1 =
        departament_id !== null
          ? `&filter[where][locationId]=${departament_id}`
          : "";
      const filter2 =
        municipality_id !== null
          ? `&filter[where][locationMunId]=${municipality_id}`
          : "";
      const filter3 =
        adaptation_level_id !== null
          ? `&filter[where][adaptationId]=${adaptation_level_id}`
          : "";
      const filter4 =
        threat_id !== null ? `&filter[where][threatId]=${threat_id}` : "";
      const filter5 =
        guild_id !== null ? `&filter[where][guildId]=${guild_id}` : "";
      const filter6 =
        objective_id !== null
          ? `&filter[where][objectiveId]=${objective_id}`
          : "";
      const filter7 =
        indicator_id !== null
          ? `&filter[where][indicatorId]=${indicator_id}`
          : "";

      const fullUrl = `${url}${filter1}${filter2}${filter3}${filter4}${filter5}${filter6}${filter7}`;

      axios
        .get(fullUrl, {})
        .then(response => {
          response.data.forEach(element => {
            this.experiences.push({
              id: element.id,
              code: element.code
            });
          });
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    refreshChart() {
      this.$refs.chart.$refs.chart.refresh()
    },
    chartData() {
      const a = this.$store.state.experiences ? this.$store.state.experiences : [];
      let result = {};
      const auxDepartments = a.map(exp => exp.locationDepartments && exp.locationDepartments.department)
      console.log(auxDepartments)

      for (let i = 0; i < auxDepartments.length; ++i) {
        const key = auxDepartments[i]
        if (result[key]) {
          ++result[key]
        } else {
          result[key] = 1
        }
      }

      let op = {
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: Object.keys(result)
        },
        yaxis: {
          forceNiceScale: true,
          decimalsInFloat: 0
        }
      };
      let s = [];
      Object.keys(result).forEach(function(key, index) {
        s.push(result[key]);
      });

      let series = [
        {
          name: "Departamento",
          data: s
        }
      ];
      this.options = op;
      this.series = series;
      setTimeout(() => {
        this.refreshChart()  
      }, 100);
      
      //return result;
    }
  },
  mounted() {
    this.reset();
  },
  computed: {
    data_checked() {
      if (this.checkedExperiences != null && this.checkedExperiences != "") {
        return true;
      }
    },
    helperExperiences() {
      return this.$store.state.experiences
    }
  }
};
</script>

<style scoped>
.container-center {
  width: 100%;
  display: flex;
  justify-content: center;
}

.container-experiences {
  background-color: #eee;
  border-radius: 5px;
  padding: 1em;
}

.width100 {
  width: 100%;
}
</style>
